export const Case_Points = {
  id: '1',
  caseDocId: '8DAEDC95-C718-4DA5-AE64-6845C3E62D24',
  tenantId: 'XBL',
  titleId: 'Moderation',
  subjectId: '59705781',
  subjectType: 'Identity',
  userId: '2535461707815405',
  userType: 'Xuid',
  caseClosedDateTime: new Date('2022-08-14T23:50:13.9872795Z'),
  caseStatus: 'Closed',
  caseClosedPoints: {
    casePointsValue: 2,
    activeTotalPointsAfterAction: 4,
    maxPoints: 6
  },
  caseOverturnedPoints: undefined
};
